module.exports = __webpack_public_path__ + "img/logo_S6.5814479b.png";